import type { CaseRecord } from '@compass/client/types/case_record';

/**
 * The nomos schema major a case was written under, for rendering it.
 *
 * Undefined until the case loads. Prefers output_data's version, then
 * input_data's (output can be empty or blank on older cases). A case with no
 * version is v1 — never the workflow's current schema.
 */
export function caseSchemaVersion(
  caseRecord: Partial<CaseRecord> | null | undefined,
): string | undefined {
  if (!caseRecord) {
    return undefined;
  }
  return caseRecord.output_data?.schema_version || caseRecord.input_data?.schema_version || 'v1';
}
